import { render, staticRenderFns } from "./FileAvatar.vue?vue&type=template&id=0b1d1f21&scoped=true&"
import script from "./FileAvatar.vue?vue&type=script&lang=js&"
export * from "./FileAvatar.vue?vue&type=script&lang=js&"
import style0 from "./FileAvatar.vue?vue&type=style&index=0&id=0b1d1f21&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b1d1f21",
  null
  
)

export default component.exports